import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/ui/utils';
import { isDustD6 } from '@/lib/validation/dust';
interface ToastPnlValueProps {
  /** Signed realised PnL (D6 base-10 string) — drives the tone. */
  amountD6: string;
  /** Host-formatted, currency-aware signed string (e.g. `+$12.34`). */
  formatted: string;
}

/**
 * Renders a realised-PnL value colour-coded by sign: profit green, loss red,
 * and a near-zero (dust) result neutral — never misrepresented as a gain or
 * loss. Used as the sell-confirmation snackbar's description (spec 110).
 */
export function ToastPnlValue(t0) {
  const $ = _c(5);
  const {
    amountD6,
    formatted
  } = t0;
  const tone = isDustD6(amountD6) ? "text-foreground-secondary" : amountD6.trim().startsWith("-") ? "text-data-loss" : "text-data-profit";
  let t1;
  if ($[0] !== tone) {
    t1 = cn("font-medium tabular-nums", tone);
    $[0] = tone;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== formatted || $[3] !== t1) {
    t2 = <span className={t1}>{formatted}</span>;
    $[2] = formatted;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}